import { Signal, signal, effect } from "@angular/core";
import { TIMEOUT_MS } from "../../constants/timeout";

export function createTimeoutSignal(loadingSignal: Signal<boolean>) {
  const timeoutSignal = signal(false);

  effect((onCleanup) => {
    const isLoading = loadingSignal();

    if (isLoading) {
      // Reset timeout when loading starts
      timeoutSignal.set(false);

      // Set timeout
      const timeoutId = setTimeout(() => {
        // Only set timeout if still loading
        if (loadingSignal()) {
          timeoutSignal.set(true);
        }
      }, TIMEOUT_MS);

      // Cleanup function - this runs when effect re-runs or component destroys
      onCleanup(() => clearTimeout(timeoutId));
    } else {
      // Reset timeout when loading stops
      timeoutSignal.set(false);
    }
  });

  return timeoutSignal.asReadonly();
}
